import { render, staticRenderFns } from "./galleryCarousel.vue?vue&type=template&id=0757c0f0"
import script from "./galleryCarousel.vue?vue&type=script&lang=js"
export * from "./galleryCarousel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports